/* eslint-disable react-hooks/exhaustive-deps */
import Helmet from "react-helmet";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import MUITheme from "./muiTheme";
import Navigation from "./navigation/";

export default function Layout(props) {
  const { children } = props;

  const config = useSelector((state) => state.config);

  return (
    <>
      <Helmet>
        <meta name="theme-color" content="#182550"></meta>
        <meta name="msapplication-navbutton-color" content="#182550"></meta>
        <meta
          name="apple-mobile-web-app-status-bar-style"
          content="#182550"
        ></meta>

        {config.GoogleIndex && <meta name="robots" content="noindex" />}
      </Helmet>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        limit={3}
        closeButton={false}
      />

      <MUITheme theme={config.Theme}>
        <Box sx={{ bgcolor: "background.default" }}>{children}</Box>
        <Navigation />
      </MUITheme>
    </>
  );
}
